import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link, useNavigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { startstopLoading } from "../Redux/Reducers/globalSlice";
import AdminActions from "../Redux/Actions/AdminActions";
import { toast } from "react-toastify";

const validationSchema = Yup.object({
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),

  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
});

const initialValues = {
  email: "",
  password: "",
};


export default function Login() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (values, { setStatus }) => {
    setStatus([]);
    dispatch(startstopLoading(true));
    try {
      dispatch(AdminActions.AdminLogin(values)).then((res) => {

        // otp verification flow

        // if (res?.payload?.status === 200) {
        //   toast.success(res?.payload?.message);
        //   navigate(`/otp-verification/${res?.payload?.data?.email}`)
        // } else {
        //   toast.error(res?.payload?.message || "Login failed!");
        // }

        // without otp verification flow
        if (res?.payload?.status === 200) {
          const token = res?.payload?.data?.token;
          if (token) {
            sessionStorage.setItem("adminToken", token);
            navigate('/chatbots')
          } else {
            toast.error("Invalid token data. Please try again.");
          }
        } else {
          toast.error(res?.payload?.message || "OTP verification failed");
          dispatch(startstopLoading(false));
        }
      });
    } catch (error) {
      console.error(error);
      dispatch(startstopLoading(false));
      setStatus([error.message || "An error occurred during login."]);
      toast.error("An error occurred during login. Please try again.");
    }
    finally {
      dispatch(startstopLoading(false));
    }
  };
  return (
    <div>
      <Container fluid>
        <Row>
          <Col lg={12}>
            <div className="logo">
              <img src={require("../Assets/Images/mcai-logo.png")} />
            </div>
          </Col>
        </Row>
      </Container>
      <Container fluid className="">
        <div className="row  sign-banner-part">
          <Col lg={8} className="p-0">
            <div className="left-banner-img"></div>
          </Col>
          <Col lg={4}>
            <div className="right-banner-part">
              <div className="login-cmn-box">
                <div className="login-box-inner-wrap">
                  <h2>Welcome to MCAI! 👋🏻</h2>
                  <p>Please sign-in to your account and start the adventure</p>
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                  // validate={(values) => {
                  //   const errors = {};
                  //   const statusErrors = [];

                  //   // Loop through the values and only validate if the field is not empty
                  //   Object.keys(values).forEach((key) => {
                  //     if (values[key] && values[key].length > 0) {
                  //       try {
                  //         validationSchema.validateSyncAt(key, values, {
                  //           abortEarly: false,
                  //         });
                  //       } catch (validationError) {
                  //         validationError.inner.forEach((err) => {
                  //           statusErrors.push(err.message);
                  //         });
                  //       }
                  //     }
                  //   });

                  //   if (statusErrors.length > 0) {
                  //     errors.statusErrors = statusErrors;
                  //   }

                  //   return errors;
                  // }}
                  >
                    {({ errors, touched, status, setStatus, isSubmitting }) => (
                      <Form>
                        {/* Show global errors only if any validation errors exist */}
                        {/* {((status && status.length > 0) || errors.statusErrors) && (
                          <div
                            className="global-error text-danger p-2 mb-3"
                            style={{
                              backgroundColor: "#f8d7da",
                              border: "1px solid #f5c6cb",
                              borderRadius: "5px",
                            }}
                          >
                            <ul className="mb-0 p-0 text-center">
                              {errors?.statusErrors?.map((err, index) => (
                                <li style={{ listStyle: "none" }} key={index} className="h6 mb-0">
                                  {err}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )} */}

                        <div className="form-set">
                          <div className="mb-3">
                            <label htmlFor="email">Email</label>
                            <Field
                              type="email"
                              name="email"
                              id="email"
                              className="form-control"
                              placeholder="Enter your email"
                            />
                            <ErrorMessage
                              name="email"
                              component="div"
                              className="text-danger"
                            />
                          </div>

                          <div className="mb-3 pass-eys">
                            <label htmlFor="password">Password</label>
                            <Field
                              type={showPassword ? "text" : "password"}
                              name="password"
                              id="password"
                              className="form-control password-input"
                              placeholder="Password"
                            />
                            <ErrorMessage
                              name="password"
                              component="div"
                              className="text-danger"
                            />
                            <img
                              src={require(showPassword ? "../Assets/Images/eye-off.svg" : "../Assets/Images/eye.svg").default}
                              alt="Show Password"
                              onClick={() => setShowPassword(!showPassword)}
                              style={{ cursor: "pointer" }}
                            />
                          </div>
                        </div>

                        <div className="pass-rember-line">
                          <Link to="/forgot-password" className="forgot">
                            Forgot Password?
                          </Link>
                        </div>

                        <button type="submit" className="submit" disabled={isSubmitting}>
                          Login
                        </button>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </Col>
        </div>
      </Container>
    </div>
  );
}
